import {
  PiGlobeSimpleFill,
  PiDeviceMobileCameraLight,
  PiRocketLaunchFill,
  PiChat,
  PiSmileyFill,
  PiMedalFill,
  PiUsersThreeFill,
  PiSealCheck,
  PiStarFourFill,
  PiShieldCheckFill,
  PiSealCheckFill,
} from "react-icons/pi";
import Plat1 from "../../assets/images/platform-ft-first.png";
import Plat2 from "../../assets/images/platform-ft-second.png";
import Plat3 from "../../assets/images/platform-ft-third.png";
import Plat4 from "../../assets/images/platform-ft-fourth.png";
import Plat5 from "../../assets/images/platform-ft-fift.png";
import { FaBoltLightning } from "react-icons/fa6";

const Globe = PiGlobeSimpleFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Phone = PiDeviceMobileCameraLight as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Launch = PiRocketLaunchFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Chat = PiChat as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Smiley = PiSmileyFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;

const Medal = PiMedalFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Users = PiUsersThreeFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const SealCheck = PiSealCheck as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const SealCheckFilled = PiSealCheckFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Star = PiStarFourFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Sheild = PiShieldCheckFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;

const Bolt = FaBoltLightning as React.ComponentType<{
  size?: number;
  color?: string;
}>;

export const features = [
  {
    title: "Reach Every Customer Instantly",
    subTitle:
      "Connect with customers on any device—smartphones or feature phones. Our technology ensures your messages get delivered in seconds across Africa's major networks.",
    icon: <Globe size={25} color="#2C73DB" />,
    image: Plat1,
    subSections: [
      {
        sectionTitle: "Direct connections to MTN network",
        sectionIcon: <Phone size={18} color="#2C73DB" />,
      },
      {
        sectionTitle: "SMS, USSD, mobile apps—all in one platform",
        sectionIcon: <Chat size={18} color="#2C73DB" />,
      },
      {
        sectionTitle: "Launch campaigns in under 2 weeks",
        sectionIcon: <Launch size={18} color="#2C73DB" />,
      },
      {
        sectionTitle: "99.9% uptime guarantee",
        sectionIcon: <SealCheck size={18} color="#2C73DB" />,
      },
    ],
  },

  {
    title: "Understand Your Customers Better",
    subTitle:
      "Know exactly who your most valuable customers are and what keeps them coming back. Our technology tracks every interaction and turns it into insights you can actually use.",
    icon: <Smiley size={25} color="#2C73DB" />,
    image: Plat2,
    subSections: [
      {
        sectionTitle: "Real-time customer behavior tracking",
        sectionIcon: <Phone size={18} color="#2C73DB" />,
      },
      {
        sectionTitle: "Predict which customers might leave (85%+ accuracy)",
        sectionIcon: <Chat size={18} color="#2C73DB" />,
      },
      {
        sectionTitle: "Automatic customer segmentation",
        sectionIcon: <Launch size={18} color="#2C73DB" />,
      },
      {
        sectionTitle: "Instant insights, not days of analysis",
        sectionIcon: <SealCheck size={18} color="#2C73DB" />,
      },
    ],
  },

  {
    title: "Build Loyalty That Lasts",
    subTitle:
      "Reward your best customers with points, perks, and prizes they'll love. Our technology handles all the complexity—you just watch engagement soar.",
    icon: <Medal size={25} color="#2C73DB" />,
    image: Plat3,

    subSections: [
      {
        sectionTitle: "Flexible points and rewards programs",
        sectionIcon: <Phone size={18} color="#2C73DB" />,
      },
      {
        sectionTitle: "VIP tiers with exclusive benefits",
        sectionIcon: <Chat size={18} color="#2C73DB" />,
      },
      {
        sectionTitle: "Instant reward redemption",
        sectionIcon: <Launch size={18} color="#2C73DB" />,
      },
      {
        sectionTitle: "Gamification that keeps customers coming back",
        sectionIcon: <SealCheck size={18} color="#2C73DB" />,
      },
    ],
  },

  {
    title: "Easy Team Collaboration",
    subTitle:
      "Your entire team can manage campaigns, track results, and optimize engagement from one simple dashboard. No technical skills required.",
    icon: <Users size={25} color="#2C73DB" />,
    image: Plat4,

    subSections: [
      {
        sectionTitle: "Intuitive dashboard anyone can use",
        sectionIcon: <Phone size={18} color="#2C73DB" />,
      },
      {
        sectionTitle: "Real-time campaign performance tracking",
        sectionIcon: <Chat size={18} color="#2C73DB" />,
      },
      {
        sectionTitle: "Team collaboration tools built-in",
        sectionIcon: <Launch size={18} color="#2C73DB" />,
      },
      {
        sectionTitle: "Automated reporting and analytics",
        sectionIcon: <SealCheck size={18} color="#2C73DB" />,
      },
    ],
  },

  {
    title: "Simple. Powerful. Made for Africa.",
    subTitle:
      "We've built our platform specifically for African businesses. It works seamlessly with local networks, supports multiple languages, and handles millions of customers effortlessly.",
    icon: <Star size={25} color="#2C73DB" />,
    image: Plat5,

    subSections: [
      {
        sectionTitle: "Built for African telecom infrastructure",
        sectionIcon: <Phone size={18} color="#2C73DB" />,
      },
      {
        sectionTitle: "Multi-language and multi-currency support",
        sectionIcon: <Chat size={18} color="#2C73DB" />,
      },
      {
        sectionTitle: "Scales from hundreds to millions of customers",
        sectionIcon: <Launch size={18} color="#2C73DB" />,
      },
      {
        sectionTitle: "Local payments—airtime, mobile money, and more",
        sectionIcon: <SealCheck size={18} color="#2C73DB" />,
      },
    ],
  },
];
export const cards = [
  {
    icon: <Sheild size={25} color="#2C73DB" />,
    title: "Licensed & Trusted",
    body: "We’re a fully licensed VAS provider with direct partnerships with major African telcos. Your data and your customers are in safe hands.",
  },
  {
    icon: <Bolt color="#fff" size={25} />,
    title: "Fast Results",
    body: "Get up and running in weeks, not months. Our platform is designed for speed, both in deployment and delivering customer engagement results.",
    highlighted: true,
  },
  {
    icon: <SealCheckFilled size={25} color="#2C73DB" />,
    title: "Proven Success",
    body: "We’ve powered campaigns for leading brands across Africa, helping them increase engagement by 14%+, boost revenue by 32%, and reduce churn by 18%.",
  },
];
export const stats = [
  {
    value: "+145%",
    title: "Customer Engagement",
    note: "Average Increase Across Campaigns",
  },
  {
    value: "+32%",
    title: "Revenue Growth",
    note: "Within Campaign Periods",
  },
  {
    value: "-18%",
    title: "Customer Churn",
    note: "Among Loyalty Program Members",
  },
];
export const whatYouLearn = [
  {
    title: "Quick Campaign Setup",
    text: "Launch SMS and rewards campaigns in minutes with our intuitive dashboard",
  },
  {
    title: "Real-Time Analytics",
    text: "Track engagement, conversion rates, and ROI as campaigns run",
  },
  {
    title: "Customer Segmentation",
    text: "Target the right customers with AI-powered insights and automation",
  },
  {
    title: "Rewards Management",
    text: "Create flexible loyalty programs with points, tiers, and instant rewards",
  },
];
